// extracted by mini-css-extract-plugin
export default {"image":"Card_image__i5ULR","videoButton":"Card_videoButton__Mc3VY","title":"Card_title__fjt9r"};